/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleCreateRequest
 */
export interface BookingIdRemarkRuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleCreateRequest
     */
    bookingIdRemark?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingIdRemarkRuleCreateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleCreateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleCreateRequest
     */
    disabled?: boolean;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingIdRemarkRuleCreateRequest
     */
    providers?: Array<GuidIdAndLabel> | null;
}

export function BookingIdRemarkRuleCreateRequestFromJSON(json: any): BookingIdRemarkRuleCreateRequest {
    return BookingIdRemarkRuleCreateRequestFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : json['bookingIdRemark'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function BookingIdRemarkRuleCreateRequestToJSON(value?: BookingIdRemarkRuleCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bookingIdRemark': value.bookingIdRemark,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'comment': value.comment,
        'description': value.description,
        'disabled': value.disabled,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


